// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createObjectURLFromResponse = (response: any, contentType: string) => {
	const arrayBuffer = [response];

	const blob = new Blob(arrayBuffer, { type: contentType });

	return URL.createObjectURL(blob);
};
